module.exports = __webpack_public_path__ + "img/modal-button-close.d6443461.svg";